import { ResponsivePie } from '@nivo/pie';
import Card from 'react-bootstrap/Card';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import { useState, useEffect } from 'react';

const valueFormat = (value, mode) => {
    if (mode === 'volume') {
        if (value >= 1_000_000) return `$${(value / 1_000_000).toFixed(1)}M`;
        if (value >= 1_000) return `$${(value / 1_000).toFixed(1)}k`;
        return `$${value}`;
    }
    return value;
};

export default function DoughnutCard( { data, centerLabel, height = 250, mode = 'units' }) {
  useEffect( () => {
    console.log( 'donut: ', data );
  }, [ data ] );

    return (
        <div style={ { position: 'relative', height: height } }>
            <ResponsivePie
                data={data}
                margin={{ top: 30, right: 20, bottom: 30, left: 20 }}
                innerRadius={0.55}
                padAngle={1.5}
                cornerRadius={4}
                activeOuterRadiusOffset={8}
                borderWidth={1}
                borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
                // arcLinkLabelsSkipAngle={10}
                // arcLinkLabelsTextColor="#333"
                // arcLinkLabelsThickness={2}
                arcLabelsTextColor="#fff"
                // arcLinkLabel={d => `${d.id}: ${d.value}`}
                arcLinkLabelsColor={{ from: 'color' }} 
                enableArcLabels={true}
                colors={ [ '#90caf9', '#42a5f5', '#1e88e5', '#81c784', '#66bb6a' ] }
                // tooltip={({ datum }) => (
                //     <div style={{ fontSize: 12 }}>
                //         <strong>{datum.label}</strong>: {valueFormat(datum.value, mode)}
                //     </div>
                // )}
                // arcLabelsComponent={({ datum }) => (
                //     <text
                //         x={datum.labelPosition.x}
                //         y={datum.labelPosition.y}
                //         textAnchor="middle"
                //         dominantBaseline="central"
                //         style={{
                //         fill: 'white',
                //         fontSize: 11,
                //         fontWeight: 600,
                //         pointerEvents: 'none'
                //         }}
                //     >
                //         {datum.label}
                //     </text>
                // )}
            />
            {
                ( centerLabel ) ? (
                    <div style={ {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        pointerEvents: 'none',
                        textAlign: 'center',
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#444',
                        } }
                    >
                        {centerLabel}
                    </div>
                ) : ( null )
            }
        </div>
    );
}